import { getAccountId } from './common';
import getAxios from './common/header';
import { postApi, getApi } from './common/apis';
import { directoryTree } from './common/directoryCode';

export default class AnswerBankService {
    async getTemplates() {
        try {
            var response = await getApi(`v1/template/answer-bank`, process.env.VUE_APP_ANSWER_BANK_SERVICE_URL);
            return await response;
        } catch (err) {
            console.error('Error', err.stack);
            return err.response;
        }
    }

    async getTemplateById(id, admin = false) {
        try {
            let isAdmin = localStorage.getItem('isAdmin') ?? admin;
            var response = await getApi(
                `v2/template/answer-bank/?qsid=${id}&isAdmin=${isAdmin}`,
                process.env.VUE_APP_ANSWER_BANK_SERVICE_URL
            );
            return await response;
        } catch (err) {
            console.error('Error', err.stack);
            return err.response;
        }
    }

    async getAnswers(qsid) {
        const accountId = getAccountId();
        try {
            var response = await getApi(
                `v2/answer-bank/?id=${accountId}&qsid=${qsid}`,
                process.env.VUE_APP_ANSWER_BANK_SERVICE_URL
            );
            return await response;
        } catch (err) {
            console.error('Error', err.stack);
            return err.response;
        }
    }

    async postAnswers(payload, qsid) {
        const accountId = getAccountId();
        var answerBankQuestions = await getAxios().post(
            `${process.env.VUE_APP_ANSWER_BANK_SERVICE_URL}v2/answer-bank?id=${accountId}&qsid=${qsid}`,
            JSON.parse(JSON.stringify(payload))
        );
        return answerBankQuestions;
    }

    async getAnswerBankAccess() {
        const accountId = getAccountId();
        try {
            var response = await getApi(`v2/answer-bank/access?id=${accountId}`, process.env.VUE_APP_ANSWER_BANK_SERVICE_URL);
            return await response;
        } catch (err) {
            console.error('Error', err.stack);
            return err.response;
        }
    }

    async postAnswerBankAccess(payload) {
        const accountId = getAccountId();
        try {
            var response = await getAxios().post(
                `${process.env.VUE_APP_ANSWER_BANK_SERVICE_URL}v2/answer-bank/access?id=${accountId}`,
                JSON.parse(JSON.stringify(payload))
            );
            return response;
        } catch (err) {
            console.error('Error', err.stack);
            return err.response;
        }
    }

    async getDirectoryTree() {
        const accountId = getAccountId();
        try {
            var response = await getApi(`v3/answer-bank/directory?id=${accountId}`);
            return await response;
        } catch (err) {
            console.error('Error', err.stack);
            return err.response;
        }
    }

   async getDirectoryTreeData() {

        let data = await directoryTree();
        return data;
    }

    // Publish-gate state lives in Portal Backend (vendor_profile_publication
    // Lambda), not AnswerBank.Service. These two helpers default to the
    // Portal Backend base URL via getApi/postApi.
    async getPublicationStatus(qsid) {
        const accountId = getAccountId();
        try {
            const response = await getApi(`v1/vendor-profile-publication?id=${accountId}&qsid=${qsid}`);
            return response;
        } catch (err) {
            console.error('Error', err.stack);
            return err.response;
        }
    }

    async setPublicationStatus(qsid, isPublished) {
        const accountId = getAccountId();
        try {
            const response = await postApi(
                `v1/vendor-profile-publication?id=${accountId}&qsid=${qsid}`,
                { is_published: !!isPublished }
            );
            return response;
        } catch (err) {
            console.error('Error', err.stack);
            return err.response;
        }
    }

    // Section confirmation endpoints live in AnswerBank.Service (per-section
    // attestation log + summary that drives the publish gate).
    async getSectionStatus(qsid) {
        const accountId = getAccountId();
        try {
            const response = await getApi(
                `v2/answer-bank/sections?id=${accountId}&qsid=${qsid}`,
                process.env.VUE_APP_ANSWER_BANK_SERVICE_URL
            );
            return response;
        } catch (err) {
            console.error('Error', err.stack);
            return err.response;
        }
    }

    async postSectionConfirm(qsid, categoryId, confirmedBy, notes = null) {
        const accountId = getAccountId();
        try {
            const response = await getAxios().post(
                `${process.env.VUE_APP_ANSWER_BANK_SERVICE_URL}v2/answer-bank/section-confirm?id=${accountId}`,
                { qsid, category_id: categoryId, confirmed_by: confirmedBy, notes }
            );
            return response;
        } catch (err) {
            console.error('Error', err.stack);
            return err.response;
        }
    }
}
